import React, { useState } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import MobilRightMenuSlider from "@material-ui/core/Drawer";
//import avatar from "../images/avatar.jpg";
import logo from "../images/logo.png";
import {
  Toolbar,
  ListItem,
  IconButton,
  ListItemText,
  ListItemIcon,
  Avatar,
  AppBar,
  Divider,
  List,
  Box,
} from "@material-ui/core";
import { Menu, Work, Home, Apps, ContactMail } from "@material-ui/icons";

const useStyle = makeStyles((theme) => ({
  menuSliderContainer: {
    width: 250,
    backgroundColor: "#f5f5f5",
    height: "100rem",
  },
  avatar: {
    margin: "10px auto",
    display: "block",
    width: theme.spacing(13),
    height: theme.spacing(13),
  },
  listIcon: {
    color: "#f7550e",
  },
}));
const menuIcons = [
  {
    listIcon: <Home />,
    listText: "Home",
    listPath: "/",
  },
  //{
  // listIcon: <Info />,
  // listText: "About",
  // listPath: "/about",
  //},
  {
    listIcon: <Apps />,
    listText: "Projects",
    listPath: "/projects",
  },
  {
    listIcon: <Work />,
    listText: "Work Experience",
    listPath: "/work-experience",
  },
  {
    listIcon: <ContactMail />,
    listText: "Contact",
    listPath: "/contact-me",
  },
];

const Navbar = (props) => {
  const [state, setState] = useState({
    right: false,
  });

  const toggleSlider = (slider, open) => () => {
    setState({ ...state, [slider]: open });
  };
  const classes = useStyle();
  const sideList = (slider) => (
    <Box
      className={classes.menuSliderContainer}
      component="div"
      onClick={toggleSlider(slider, false)}
    >
      <Avatar className={classes.avatar} src={logo} alt="Nikhil Tripathi" />
      <Divider />
      <List>
        {menuIcons.map((lsItem, key) => (
          <ListItem button key={key} component={Link} to={lsItem.listPath}>
            <ListItemIcon className={classes.listIcon}>
              {lsItem.listIcon}
            </ListItemIcon>
            <ListItemText
              className={classes.listIcon}
              primary={lsItem.listText}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
  return (
    <Box component="nav">
      <AppBar position="fixed" style={{ backgroundColor: "transparent" }}>
        <Toolbar
          style={{
            justifyContent: "space-between",
          }}
        >
          <img
            style={{ heigh: "4rem", width: "4rem" }}
            src={logo}
            alt={props.name}
          />

          <IconButton onClick={toggleSlider("right", true)} edge="end">
            <Menu style={{ color: "#26e9ff" }} fontSize="large" />
          </IconButton>
          <MobilRightMenuSlider
            anchor="right"
            open={state.right}
            onClose={toggleSlider("right", false)}
          >
            {sideList("right")}
          </MobilRightMenuSlider>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Navbar;
